import { Component, Input, OnInit } from '@angular/core';
import { UserManagement } from 'src/app/services/utils/state-management/action-classes';
import { LanguageChangeService } from '../../../services/language-change.service';
import {Config} from "../../../services/utils/gdo-config";

@Component({
  selector: 'app-gdo-battery',
  templateUrl: './gdo-battery.component.html',
  styleUrls: ['./gdo-battery.component.css']
})
export class GdoBatteryComponent implements OnInit {
  @Input() batteryVoltage: string;
  @Input() connectedAC: number;
  @Input() isUnknownStatus: boolean;
  viewType: string;
  batteryStatusLocale: string;
  batteryIcon: string;
  mediumBattery = false;
  voltage: number;
  flatBattery = false;




  constructor(private languageService: LanguageChangeService, private userManagement: UserManagement) {
    this.viewType = this.userManagement.getUserView();
  }

  ngOnInit() {
    this.batteryImage();
  }


  batteryImage() {
      this.voltage = Number.parseInt(this.batteryVoltage);
      if (this.voltage <= 2200) {
        this.batteryIcon = "../../../assets/images/gdo/battery/Battery_Flat.svg";
        this.batteryStatusLocale = Config.BATTERY.FLAT[this.languageService.getCurrentLanguage()];
        this.flatBattery = true;
      } else if (this.voltage <= 2400) {
        this.batteryIcon = "../../../assets/images/gdo/battery/Battery_Low.svg";
        this.batteryStatusLocale = Config.BATTERY.LOW[this.languageService.getCurrentLanguage()];
      } else if (this.voltage <= 2700) {
        this.mediumBattery = true;
        this.batteryIcon = "../../../assets/images/gdo/battery/Battery_Medium.svg";
        this.batteryStatusLocale = Config.BATTERY.MEDIUM[this.languageService.getCurrentLanguage()];
      } else if (this.voltage <= 3000) {
        this.batteryIcon = "../../../assets/images/gdo/battery/Battery_Full.svg";
        this.batteryStatusLocale = Config.BATTERY.FULL[this.languageService.getCurrentLanguage()];
      } else if (this.voltage > 3000) {
        this.batteryIcon = "../../../assets/images/gdo/Plug.svg";
        this.batteryStatusLocale = Config.BATTERY.AC[this.languageService.getCurrentLanguage()];
      }
  }

}
